
import { createRouter, createWebHistory, RouteRecordRaw , createWebHashHistory} from 'vue-router'
// @ts-ignore
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/index/home', // 根路径跳转到首页
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    redirect: '/index/home',
    children:[
      {
        path:'home',
        name:'home',
        component: () => import('../views/home/index.vue'),
      },
      {
        path:'introduction',
        name:'introduction',
        component: () => import('../views/introduction/index.vue'),
      },
      {
        path:'business',
        name:'business',
        component: () => import('../views/business/index.vue'),
      },
      {
        path:'honor',
        name:'honor',
        component: () => import('../views/honor/index.vue'),
      },
      {
        path:'serviceUnit',
        name:'serviceUnit',
        component: () => import('../views/serviceUnit/index.vue'),
      },
      {
        path:'news',
        name:'news',
        component: () => import('../views/news/index.vue'),
      },
      {
        path:'newsDetail',
        name:'newsDetail',
        component: () => import('../views/news/detail.vue'),
      },
      {
        path:'cooperation',
        name:'cooperation',
        component: () => import('../views/cooperation/index.vue'),
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
// @ts-ignore
router.beforeEach((to, from, next) => {
  // 中止当前页面的图片加载
  document.querySelectorAll('img').forEach((img) => {
    if (!img.complete) {
      img.src = ''
    }
  })
  next()
})
export default router
